import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DashboardPageRoutingModule } from './dashboard-routing.module';

import { DashboardPage } from './dashboard.page';
import { CoreModule } from '../core/core.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ActivityStatisticsComponent } from './activity-statistics/activity-statistics.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { Sidebar } from 'primeng/sidebar';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { Draggable, Droppable } from 'primeng/dragdrop';
import { TreeTableModule } from 'primeng/treetable';
import { CdkContextMenuTrigger, CdkMenu, CdkMenuItem } from '@angular/cdk/menu';
import { ProjectListModule } from '../projects/project-list/project-list.module';
import { TasksModule } from '../tasks/tasks.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        DashboardPageRoutingModule,
        CoreModule,
        FontAwesomeModule,
        NgSelectModule,
        TranslatePipe,
        TableModule,
        Sidebar,
        ScrollingModule,
        TasksModule,
        Draggable,
        Droppable,
        TreeTableModule,
        CdkContextMenuTrigger,
        CdkMenu,
        CdkMenuItem,
        ProjectListModule,
    ],
    declarations: [DashboardPage, ActivityStatisticsComponent, NotificationsComponent],
    exports: [NotificationsComponent],
})
export class DashboardPageModule {}
